
   <div class="modal-body">
    <button type="button" class="close pull-right" aria-label="Close" (click)="unBetLimitListModalDelete()">
      <span aria-hidden="true">×</span>
    </button>
    <div class="section full">
      <div class="row mt-3">
        <div class="col-6" *ngFor="let unBetLimitListObj of data;">
          {{ unBetLimitListObj.number }} = {{ unBetLimitListObj.amount | number:'1.0':'en-US'}} {{'ks' |
          translate}}
        </div>
      </div>
    </div>
    <div class="mt-1">
      <p class="text-danger">{{'unbetlist_text' | translate}}</p>
    </div>

  </div>